(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {

        const section = document.querySelector('.pwr-tech');

        if (!section) return;

        const hotspots = section.querySelectorAll('[data-pwr-hotspot]');
        const cards = section.querySelectorAll('[data-pwr-hotspot-panel]');

        function activate(id) {

            // -----------------------------
            // Hotspots
            // -----------------------------

            hotspots.forEach(hotspot => {

                hotspot.classList.remove('is-active');

                if (hotspot.dataset.pwrHotspot === id) {
                    hotspot.classList.add('is-active');
                }

            });

            // -----------------------------
            // Cards
            // -----------------------------

            cards.forEach(card => {

                card.classList.remove('is-active');

                if (card.dataset.pwrHotspotPanel === id) {

                    card.classList.add('is-active');

                    card.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });

                }

            });

        }

        //--------------------------------
        // Click on Hotspot
        //--------------------------------

        hotspots.forEach(hotspot => {

            hotspot.addEventListener('click', function () {

                activate(this.dataset.pwrHotspot);

            });

        });

        //--------------------------------
        // Click on Card
        //--------------------------------

        cards.forEach(card => {

            card.addEventListener('click', function () {

                activate(this.dataset.pwrHotspotPanel);

            });

        });

        //--------------------------------
        // Default Active
        //--------------------------------

        activate("1");

    });

})();